export default __webpack_public_path__ + "static/media/alert-triangle-xl.eabad256.svg";